module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07481_logo_200x200.e218828e.png";